import type { MeshFlaws } from ".."
import { findDeadEnds } from "./findDeadEnds"
import { findIntersectingEdges } from "./findIntersecting"
import { sortNodesXY } from "../../2d"
import type { MeshExtracted } from "../extract"

export const findFlaws = (mesh: MeshExtracted): MeshFlaws => {
  const nodesByXY = sortNodesXY(Array.from(mesh.nodes.values()))

  const badNodes = findDeadEnds(mesh.nodes)
  const badEdges = findIntersectingEdges(nodesByXY, mesh.edges)

  const nodeIds = Array.from(badNodes.values()).map((node) => node.id)
  const edgeIds = Array.from(badEdges.values()).map((edge) => edge.id)

  return { NODE: nodeIds, EDGE: edgeIds }
}
